import { ElementNode } from 'lexical';

export class LayoutContainerNode extends ElementNode {
  __templateColumns;

  static getType() {
    return 'layout-container';
  }

  static clone(node) {
    return new LayoutContainerNode(node.__templateColumns, node.__key);
  }

  constructor(templateColumns, key) {
    super(key);
    this.__templateColumns = templateColumns || '1fr 1fr';
  }

  createDOM(config) {
    const dom = document.createElement('div');
    dom.style.display = 'grid';
    dom.style.gridTemplateColumns = this.__templateColumns;
    dom.style.gap = '10px';
    dom.style.gridAutoRows = '1fr';
    if (config.theme.layoutContainer) {
      dom.className = config.theme.layoutContainer;
    }
    return dom;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__templateColumns !== this.__templateColumns) {
      dom.style.gridTemplateColumns = this.__templateColumns;
    }
    return false;
  }

  static importDOM() {
    return {
      div: (domNode) => {
        if (!domNode.classList.contains('PlaygroundEditorTheme__layoutContainer')) {
          return null;
        }
        return {
          conversion: (node) => {
            const templateColumns = node.style.gridTemplateColumns || '1fr 1fr';
            return { node: $createLayoutContainerNode(templateColumns) };
          },
          priority: 2,
        };
      },
    };
  }

  static importJSON(json) {
    return $createLayoutContainerNode(json.templateColumns);
  }

  isShadowRoot() {
    return true;
  }

  canBeEmpty() {
    return false;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      templateColumns: this.__templateColumns,
      type: 'layout-container',
      version: 1,
    };
  }

  getTemplateColumns() {
    return this.getLatest().__templateColumns;
  }

  setTemplateColumns(templateColumns) {
    this.getWritable().__templateColumns = templateColumns;
  }
}

export function $createLayoutContainerNode(templateColumns) {
  return new LayoutContainerNode(templateColumns);
}

export function $isLayoutContainerNode(node) {
  return node instanceof LayoutContainerNode;
}
